import { render } from "./NavLink.vue?vue&type=template&id=470b6632"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"
script.render = render

export default script